import { API, setAuthToken } from '../../../config/API.js';
import { GET_LAPORAN_TAHUNAN, SET_LOADING_LAPORAN_TAHUNAN, SET_PAGINATION_LAPORAN_TAHUNAN } from '../constant.js';

export const getLaporanTahunan = (params) => {
  return (dispatch) => {
    const token = localStorage.getItem("jwt_token");
    setAuthToken(token);
    dispatch({
      type: SET_LOADING_LAPORAN_TAHUNAN,
      payload: true,
    });
    API.get(`admin/relation/annual?${new URLSearchParams(params).toString()}`)
      .then((res) => {
        dispatch({
          type: GET_LAPORAN_TAHUNAN,
          payload: res.data.data || [],
        });
        dispatch({
          type: SET_PAGINATION_LAPORAN_TAHUNAN,
          payload: res?.data?.data?.last_page,
        });
      })
      .catch(() => {
        dispatch({
          type: GET_LAPORAN_TAHUNAN,
          payload: [],
        });
        dispatch({
          type: SET_PAGINATION_LAPORAN_TAHUNAN,
          payload: 0,
        });
      });
  };
};

export const addLaporanTahunan = (params) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.post("admin/relation/annual/add", params);
};

export const getDetailLaporanTahunan = (id) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.get("admin/relation/annual/" + id);
};

export const updLaporanTahunan = (params) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.post("admin/relation/annual/edit", params);
};

export const delLaporanTahunan = (code) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.delete("admin/relation/annual/delete/" + code);
};
